var Shopify = Shopify || {};
// === Money format handler ===

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || document.querySelector("html").dataset.moneyFormat;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.emitEvent = function (eventName, detail = {}) {
  document.dispatchEvent(
    new CustomEvent(eventName, {
      detail,
      bubbles: true,
    }),
  );
};

// === Cart count badge: live update on cart:refresh ===

Shopify.updateCartBadges = function (count) {
  const badges = [
    document.getElementById("cart-count-badge-mobile"),
    document.getElementById("cart-count-badge-desktop"),
  ];
  badges.forEach(function (badge) {
    if (!badge) return;
    badge.textContent = count;
    if (count > 0) {
      badge.classList.remove("hidden");
    } else {
      badge.classList.add("hidden");
    }
  });
};

window.announceToScreenReader = function (message) {
  const el = document.getElementById("a11y-status-message");
  if (el) {
    el.textContent = "";
    setTimeout(function () {
      el.textContent = message;
    }, 50);
  }
};

window.addEventListener("cart:refresh", function () {
  fetch("/cart.js")
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      Shopify.updateCartBadges(cart.item_count);
      window.announceToScreenReader(`Cart updated. Total items: ${cart.item_count}`);
    })
    .catch(function (err) {
      console.error("[cart:refresh]", err);
    });
});
